/** Defines the React context for Free-tier project-creation wall guards. */
// @ts-check
import { createContext } from 'react';

/**
 * @typedef {Object} ProjectLimitWallContextValue
 * @property {(projectTerms: string[] | null | undefined) => boolean} guardProjects
 *   Returns true when creation may proceed; false when blocked (modal shown).
 */

/** @type {import('react').Context<ProjectLimitWallContextValue | null>} */
export const ProjectLimitWallContext = createContext(null);
